'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

var _sizes = require('../../../constants/sizes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CallIcon = function (_React$Component) {
    _inherits(CallIcon, _React$Component);

    function CallIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CallIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CallIcon.__proto__ || Object.getPrototypeOf(CallIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (primary) {
            return _react2.default.createElement(
                'svg',
                { id: 'call-talking-solid', xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24' },
                _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: '24', height: '24', fill: 'transparent' }),
                _react2.default.createElement('path', { id: 'Icon_color', 'data-name': 'Icon color', d: 'M14,18a10.071,10.071,0,0,1-4.779-1.23l-.451-.25A18,18,0,0,1,1.439,9.191L1.19,8.741A10.07,10.07,0,0,1,0,4V3.332A2,2,0,0,1,.59,1.912L2.279.222a.75.75,0,0,1,1.18.15L5.71,4.231a1,1,0,0,1-.161,1.211L3.659,7.331a.5.5,0,0,0-.09.591l.35.659a13.522,13.522,0,0,0,5.5,5.489l.66.361a.5.5,0,0,0,.59-.091l1.89-1.889a1,1,0,0,1,1.21-.161l3.859,2.25a.75.75,0,0,1,.15,1.18l-1.69,1.69a2,2,0,0,1-1.42.591ZM12,7.581a2,2,0,0,0-1.6-1.569.491.491,0,0,1-.4-.49v-1a.5.5,0,0,1,.17-.38h.021a.519.519,0,0,1,.4-.14,4.05,4.05,0,0,1,3.4,3.41.52.52,0,0,1-.12.4.5.5,0,0,1-.38.169H12.481A.489.489,0,0,1,12,7.581Zm5.5.4h-1a.5.5,0,0,1-.5-.46A6,6,0,0,0,10.479,2,.5.5,0,0,1,10,1.5V.5a.514.514,0,0,1,.15-.37.529.529,0,0,1,.4-.13A8,8,0,0,1,18,7.451a.536.536,0,0,1-.13.381.518.518,0,0,1-.363.15Z', transform: 'translate(3 3)', fill: primary })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CallIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _layout2.default,
                { size: _sizes.Sizes.md },
                this.getIcon(this.props.primary)
            );
        }
    }]);

    return CallIcon;
}(_react2.default.Component);

exports.default = CallIcon;